import clickOutside from "../directives/click-ouside.js";

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

import Inputmask from "inputmask";

const GlobalDirectives = {
  install(Vue) {
    Vue.directive("click-outside", clickOutside);
    Vue.directive("mask", {
      bind: function(el, binding) {
        Inputmask(binding.value).mask(el);
      }
    });
  }
};

export default GlobalDirectives;
